export enum RuleType {
    Conditional = 'if_then_rule',
    Behavioral = 'moderation_rule',
    Antispam = 'antispam_rule',
    Onboarding = 'onboarding_rule',
    Reputation = 'reputation_rule',
}
